import { useEffect } from 'react'
const KEYBOARD_HEIGHT_THRESHOLD = 150


const UseMobileLayout = () => {
    useEffect(()=>{
        document.body.classList.add("modal-open")
        return () => {
            document.body.classList.remove("modal-open")
        }
    },[])

    return
}

export default UseMobileLayout